import React, { useState } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'

import SubmitButton from '../shared/submit-button'
import Content from '../shared/content'
import Text from '@/components/Form/Text'
import HelpText from '@/components/Form/HelpText'
import { AuthModalBody } from '../auth-modal/auth-modal-body'
import { useAuthNavigation } from '../../hooks/use-auth-navigation'
import { forgotPasswordSchema } from '../../validations/auth-schemas'
import { authApi } from '../../services/auth-api'
import { AUTH_LOGIN_PATH } from '../../utils/auth-return'
import { AuthTextField, Logo } from '../shared'

export default function ForgotPasswordForm () {
  const { goToLogin, goToLobby } = useAuthNavigation()
  const [status, setStatus] = useState('')

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm({
    resolver: zodResolver(forgotPasswordSchema),
    defaultValues: { email: '' },
    mode: 'onChange',
  })

  const onSubmit = async ({ email }) => {
    setStatus('')
    try {
      const response = await authApi.recoverPassword(email)
      setStatus(response.data.success ? 'SUCCESS' : 'ERROR')
    } catch (error) {
      setStatus('ERROR')
    }
  }

  return (
    <AuthModalBody>
      <Logo src='/images/Pickwin.png' alt='Pickwin logo' />

      {(!status || status === 'ERROR') && (
        <Content>
          <div>RECUPERAR PASSWORD</div>
          <Text>
            Se enviarán instrucciones para cambiar tu contraseña al email con el que te registraste.
          </Text>
          <AuthTextField
            control={control}
            name='email'
            placeholder='Email'
            iconSrc='/images/Icono Mail.png'
            autoComplete='email'
          />
          {status === 'ERROR' && (
            <Text type='error'>
              El email que ingresaste no existe, por favor ingrésalo nuevamente.
            </Text>
          )}
          <SubmitButton
            onClick={handleSubmit(onSubmit)}
            disabled={!isValid}
          >
            Recuperar Contraseña
          </SubmitButton>
        </Content>
      )}

      {status === 'SUCCESS' && (
        <Content>
          <Text>Ahora revisa tu correo para restablecer tu contraseña.</Text>
          <i
            className='ion-checkmark-circled'
            style={{ color: '#78BC28', fontSize: '52px', textAlign: 'center' }}
          />
          <div className='btn-wrapper'>
            <SubmitButton onClick={goToLobby}>
              Regresar al Lobby Principal
            </SubmitButton>
          </div>
        </Content>
      )}

      <HelpText style={{ marginBottom: 0 }}>
        ¿Ya recuerdas tu contraseña?{' '}
        <LoginLink
          to={AUTH_LOGIN_PATH}
          onClick={(event) => {
            event.preventDefault()
            goToLogin()
          }}
        >
          Iniciar sesión
        </LoginLink>
      </HelpText>
    </AuthModalBody>
  )
}

const LoginLink = styled(Link)`
  color: #88ba44;
  font-weight: bold;
  margin: 0 0.4em;
  text-decoration: none;

  :hover {
    opacity: 0.8;
  }
`
